class Resizer {
  constructor() {
    this.targets = new Map();
    this.listeners = new Set();
    this.active = false;
    this.animRequest = 0;
  }

  init(props) {
    this.active = true;
    if ('onorientchange' in window) {
      window.addEventListener('orientationchange', () => this.handleResize());
    }
    window.addEventListener('resize', () => this.handleResize());
    if (props && props.targets) {
      this.addTargets(props.targets);
    }
  }

  force() {
    this.requestDispatch();
  }

  addTargets(targets) {
    if (Array.isArray(targets)) {
      targets.forEach((target) => this.addTarget(target));
    }
  }

  addTarget(target) {
    if (!this.targets.has(target.label)) {
      this.targets.set(target.label, target.target);
    }
  }

  removeTarget(label) {
    if (this.targets.has(label)) {
      this.targets.delete(label);
    }
  }

  addListener(listener) {
    if (!this.listeners.has(listener)) {
      this.listeners.add(listener);
    }
  }

  removeListener(listener) {
    if (this.listeners.has(listener)) {
      this.listeners.delete(listener);
    }
  }

  handleResize() {
    this.requestDispatch();
  }

  requestDispatch() {
    if (this.animRequest || !this.active) {
      return;
    }
    this.animRequest = window.requestAnimationFrame(() => this.dispatch());
  }

  dispatch() {
    this.animRequest = null;
    const obj = {};
    this.targets.forEach((target, key) => {
      if (target === window) {
        obj[key] = {
          width: window.innerWidth,
          height: window.innerHeight,
        };
      } else {
        obj[key] = {
          width: target.clientWidth,
          height: target.clientHeight,
          minWidth: target.style.minWidth || 0,
          minHeight: target.style.minHeight || 0,
          maxWidth: target.style.maxWidth || Infinity,
          maxHeight: target.style.maxHeight || Infinity,
        };
      }
    });
    this.listeners.forEach((listener) => {
      try {
        listener(obj);
      } catch (error) {
        console.log(`Listener: '${listener}' not found.`);
      }
    });
  }
}

export default new Resizer();
